// Phase 5 ranked list reducers for the Polaris slice: pages of the list and
// the order they are read in. Split out of polarisSlice to keep that file
// within the repo's per-file size budget.
import {ActionReducerMapBuilder, isAnyOf} from "@reduxjs/toolkit";
import type {TPolarisReducerState} from "store/polaris/types";
import {candidateSortChanged, loadCandidates} from "./searchRunThunks";

// Matchers only, so the slice can register them after all its addCase calls.
export const addRankedListMatchers = (builder: ActionReducerMapBuilder<TPolarisReducerState>) => {
	builder
		.addMatcher(candidateSortChanged.match, (state, action) => {
			state.search_run.sort = action.payload;
		})
		.addMatcher(isAnyOf(loadCandidates.fulfilled), (state, action) => {
			const {results, pagination, sort} = action.payload;
			const run = state.search_run;

			// Read in the other order: the viewer changed it while this page
			// was on its way, and the page for the new order follows.
			if (sort && run.sort && sort !== run.sort) return;

			if (sort) run.sort = sort;

			run.candidates =
				(pagination.offset ?? 0) === 0 ? results : [...run.candidates, ...results];
			run.candidates_total = pagination.count ?? run.candidates_total;
		});
};
